import Api from '@/services/Api'
const path = 'doctypes'

export default {
    get() {
        return Api().get(path, {})
    }
}